import '../scss/single-case.scss';

import { animateCounters } from './counters.js';
import { initScrollAnimations } from './comet-animation.js';
import { initCarouselCase } from './carousel-case.js';

document.addEventListener('DOMContentLoaded', function () {
    animateCounters('.counter-animate');
    initScrollAnimations();
    initCarouselCase();
});